import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import type { FC, SVGProps } from 'react';
import type { AlertProps, AlertType } from './types';

const ICONS: Record<AlertType, FC<SVGProps<SVGSVGElement>>> = {
  success: CircleCheck,
  warning: TriangleAlert,
  error: CircleAlert,
};

const Alert: FC<AlertProps> = ({ type, children, className = '', infoTooltipMsg }) => {
  const Icon = ICONS[type];

  return (
    <div className={`alert alert--${type} ${className}`}>
      <Icon className="alert__icon" />
      <div className="alert__content">
        {children}
        {infoTooltipMsg && (
          <span className="alert__info" data-tooltip={infoTooltipMsg}>
            <Info size={15} />
          </span>
        )}
      </div>
    </div>
  );
};

export default Alert;
